import styled from 'styled-components';
import dt from '../../../../shared/theme';
import { DropdownIcon } from '../../common/dropdown/styles';

const SDropdownIcon = styled(DropdownIcon)`
  font-size: 8px;
  margin-left: 16px;
`;

const Button = styled.button`
  height: 36px;
  background: #1F293A;
  color: ${props => dt(props).theme.bodyBackgroundColor};
  border: none;
  border-radius: 4px;
  outline: none;
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightHeavy};
  font-size: 14px;
  line-height: 120%;
  text-transform: uppercase;
  padding: 0 22px;
`;

const Clear = styled.span`
  color: #8EA3B5;
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightHeavy};
  font-size: 16px;
  line-height: 120%;
  text-transform: uppercase;
  opacity: 0.4;

  &.active {
    opacity: unset;

    :hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;

export {
  Button,
  Clear,
  SDropdownIcon,
};
